import { collections } from '@/mocks/guaHome';

export default function CollectionZones() {
  return (
    <section id="archive" className="scroll-mt-20 bg-amber-50/40">
      <div className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20">
        <div className="mb-8 flex flex-col gap-3 md:mb-10 md:flex-row md:items-end md:justify-between">
          <div>
            <div className="flex items-center gap-3">
              <span className="flex h-8 items-center rounded-full bg-red-600/10 px-3 text-xs font-bold tracking-widest text-red-600">04 · 合集</span>
              <span className="text-xs font-medium tracking-widest text-stone-400 uppercase">Archive</span>
            </div>
            <h2 className="font-serif-sc mt-3 text-2xl font-bold text-stone-900 md:text-3xl">合集存档 · 按题材一档一装</h2>
            <p className="mt-2 max-w-2xl text-sm text-stone-500">散落四处的同类瓜，统一按题材归进同一档合集，补哪类直接进对应档，不用再一篇篇找。</p>
          </div>
          <a
            href="#timeline"
            className="flex items-center gap-1 self-start whitespace-nowrap rounded-full border border-stone-300 bg-white px-4 py-2 text-sm font-medium text-stone-700 transition-colors hover:border-red-400 hover:text-red-600 md:self-auto"
          >
            或按年份目录翻
            <i className="ri-arrow-right-s-line" />
          </a>
        </div>

        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {collections.map((c) => (
            <a
              key={c.id}
              href="#timeline"
              className="group relative overflow-hidden rounded-2xl border border-stone-200/70 bg-white p-5 transition-all hover:-translate-y-1"
            >
              <div className={`pointer-events-none absolute inset-x-0 top-0 h-24 bg-gradient-to-b ${c.tone.split(' ')[0]} to-transparent`} aria-hidden="true" />
              <div className="relative">
                <div className="flex items-center justify-between">
                  <span className="text-xs font-bold tracking-widest text-stone-400">{c.no}</span>
                  <span className={`whitespace-nowrap rounded-full border bg-white/70 px-2.5 py-0.5 text-[11px] font-bold ${c.tone.split(' ')[3]} ${c.tone.split(' ')[2]}`}>
                    {c.count}
                  </span>
                </div>
                <h3 className="font-serif-sc mt-4 text-lg font-bold leading-snug text-stone-900 group-hover:text-red-600">
                  {c.name}
                </h3>
                <p className="mt-2 line-clamp-2 text-[13px] leading-relaxed text-stone-500">{c.desc}</p>
                <div className="mt-5 flex items-center justify-between border-t border-dashed border-stone-200 pt-3">
                  <span className="text-xs text-stone-400">{c.period}</span>
                  <span className="flex h-7 w-7 items-center justify-center rounded-full bg-stone-900 text-white transition-all group-hover:bg-red-600">
                    <i className="ri-arrow-right-line text-sm" />
                  </span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}